export const issuersNotAllowed = ['unknown', 'maestro', 'discover', 'unionpay'];
